<template>
  <footer class="global-footer">
    <div class="global-footer__inner">
      <div class="global-footer__brand">
        <div class="global-footer__mark">H</div>
        <div>
          <p>HOVA AI</p>
          <span>© {{ currentYear }}. All rights reserved.</span>
        </div>
      </div>

      <div class="global-footer__links" aria-label="HOVA AI contact links">
        <a href="tel:0793090500" class="global-footer__link">
          <vue-feather type="phone" size="14" />
          <span>079 30 90 500</span>
        </a>
        <a href="mailto:info@hova.ai" class="global-footer__link">
          <vue-feather type="mail" size="14" />
          <span>info@hova.ai</span>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "GlobalFooter",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.global-footer {
  border-top: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  color: var(--hs-muted, #64748b);
  margin-top: auto;
  padding: 0.85rem var(--dashboard-content-x, 1rem) 1rem;
}

.global-footer__inner {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  min-height: 3.25rem;
}

.global-footer__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.global-footer__mark {
  align-items: center;
  background: color-mix(in srgb, var(--hs-primary, #3293ec) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--hs-primary, #3293ec) 18%, transparent);
  border-radius: 10px;
  color: var(--hs-primary, #3293ec);
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.82rem;
  font-weight: 950;
  height: 2.2rem;
  justify-content: center;
  width: 2.2rem;
}

.global-footer__brand p {
  color: var(--hs-text, #0f172a);
  font-size: 0.82rem;
  font-weight: 950;
  line-height: 1.2;
  margin: 0;
}

.global-footer__brand span {
  color: var(--hs-muted, #64748b);
  display: block;
  font-size: 0.76rem;
  font-weight: 700;
  line-height: 1.35;
  margin-top: 0.1rem;
}

.global-footer__links {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.global-footer__link {
  align-items: center;
  border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  border-radius: 999px;
  color: var(--hs-muted, #64748b);
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 850;
  gap: 0.4rem;
  min-height: 2.15rem;
  padding: 0 0.75rem;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.global-footer__link:hover {
  background: color-mix(in srgb, var(--hs-primary, #3293ec) 6%, transparent);
  border-color: color-mix(in srgb, var(--hs-primary, #3293ec) 24%, var(--hs-border, rgba(148, 163, 184, 0.22)));
  color: var(--hs-primary, #3293ec);
}

@media (max-width: 640px) {
  .global-footer__inner {
    align-items: flex-start;
    flex-direction: column;
  }

  .global-footer__links {
    justify-content: flex-start;
    width: 100%;
  }
}
</style>
